import { useState, useEffect, useRef } from "react";
import "./Dashboard.css";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import Avatar from "react-avatar";
import { ParentEditKid } from "./UpdateDetails/EditKidPassword";
import { ParentEditKidUsername } from "./UpdateDetails/EditKidUsername";
import toast from "react-hot-toast";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import LeaveParentDashboardModal from "./LeaveParentModal";
import { useDeleteKid } from "../../../../hooks/authV2/useDeleteKid";

export const ParentDashboard = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user, logout, ClearUser, fetchWithAuth } = useAuth();
  const { studentLogin } = useAuthStudent();
  const [showModalParentLeave, setShowModalParentLeave] = useState(false);
  const [studentLoginId, setStudentLoginId] = useState("");
  const { deleteKid } = useDeleteKid();
  const [kidsData, setkidsData] = useState([]);
  const [loadingKidData, setloadingKidData] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [kidToUpdate, setkidToUpdate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalUsername, setShowModalUsername] = useState(false);
  const parent_type = "normal_parent";
  const hasShownExitToast = useRef(false);

  const unsubscribedKids =
    kidsData?.students?.filter((kid) => !kid?.is_subscribed) || [];

  const handleSingleKidPayment = (kidId) => {
    localStorage.setItem("student_ids", String(kidId));
    localStorage.setItem("number_of_kids", "1");
    navigate("/parent/payment/update");
  };

  const handlePayAllPending = () => {
    if (unsubscribedKids.length === 0) return;
    const ids = unsubscribedKids.map((k) => k.id).join(",");
    localStorage.setItem("student_ids", ids);
    localStorage.setItem("number_of_kids", String(unsubscribedKids.length));
    navigate("/parent/payment/update");
  };

  useEffect(() => {
    if (location.state?.fromPaymentExit && !hasShownExitToast.current) {
      hasShownExitToast.current = true;
      toast(
        "Kid profile saved! You can complete payment anytime to activate access.",
        {
          id: "payment-exit-toast",
          icon: "ℹ️",
          duration: 5000,
        },
      );
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const handleParentNewLogout = () => {
    logout();
    navigate("/login");
  };

  const passwordChange = (kid) => {
    setkidToUpdate(kid);
    setShowModal(true);
  };
  const UsernameChange = (kid) => {
    setkidToUpdate(kid);
    setShowModalUsername(true);
  };
  const [selectedKids, setSelectedKids] = useState([]);

  const toggleKidSelection = (kidId) => {
    setSelectedKids((prev) =>
      prev.includes(kidId)
        ? prev.filter((id) => id !== kidId)
        : [...prev, kidId],
    );
  };

  const handleBulkPayment = () => {
    if (selectedKids.length === 0) {
      toast.error("Please select at least one kid by clicking on checkbox.");
      return;
    }

    localStorage.setItem("student_ids", selectedKids.join(","));
    localStorage.setItem("number_of_kids", selectedKids?.length);

    // Call your payment logic here if needed
    navigate("/parent/payment/update");
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("accessToken") || user?.token;
      if (!token) return;

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/parent/account-details?parent_type=${parent_type}`,
          {
            method: "GET",
          },
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch kids: ${response.statusText}`);
        }

        const data = await response.json();

        // Check for dummy students whose age is null and delete them
        const dummyStudents =
          data?.students?.filter((student) => student?.age === null) || [];
        if (dummyStudents.length > 0) {
          for (const dummy of dummyStudents) {
            if (dummy?.id) {
              await deleteKid(dummy.id, fetchWithAuth);
            }
          }
        }

        const newData = {
          ...data,
          students:
            data?.students.filter((student) => student?.age != null) || [],
        };
        setkidsData(newData);
      } catch (error) {
      } finally {
        setloadingKidData(false);
      }
    };

    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const subscribedCount =
    kidsData?.students?.filter((kid) => kid?.is_subscribed)?.length || 0;
  const switchStudent = async () => {
    try {
      const response = await fetchWithAuth(`${apiUrl}/parent/student/switch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          student_id: studentLoginId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to switch student: ${response.statusText}`);
      }

      const data = await response.json();
      if (data?.student) {
        const handleStudentSwitch = async () => {
          ClearUser(); // wait until logout finishes
          studentLogin(data);
          navigate("/student/start-your-quest");
        };

        handleStudentSwitch();
      }

      return data; // return switched student data
    } catch (error) {
      throw error;
    }
  };
  const handleSwitchStudent = async () => {
    try {
      await switchStudent(studentLoginId);
      // console.log("Switched to student:", switchedStudent);
      // optionally update local state or localStorage
    } catch (err) {
      console.error("Failed to switch student", err);
    }
  };

  return (
    <>
      <div className="dashboardBody">
        <div className="container-fluid p-0">
          {" "}
          <div className="p-0" id="mainContent">
            <div className="teacher-bodycontent mb-4">
              <section>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8 text-center">
                      <p className="parentDashboardNotfy">
                        <span className="notifyParaSubHeadng">
                          <i className="fa-solid fa-exclamation exclamationLogin"></i>{" "}
                          Looking for Quests and Festivals?{" "}
                        </span>{" "}
                        Please{" "}
                        <Link
                          onClick={handleParentNewLogout}
                          className="loginNofityBtn"
                        >
                          log in
                        </Link>{" "}
                        to your kid’s dashboard and start exploring!
                      </p>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <p className="tchrdashboard-cmntitl mb-0">
                        Parent Dashboard
                      </p>
                    </div>
                    <div>
                      <button
                        onClick={() =>
                          navigate(
                            `/parent/kids/register/${kidsData?.students?.length}/${subscribedCount}`,
                          )
                        }
                        style={{ border: "none", borderRadius: "5px" }}
                        className="text-white btn btn-primary tchrdashboard-cmnbtn"
                        disabled={
                          kidsData?.students?.length === 5 || loadingKidData
                        }
                      >
                        + Add Kid
                      </button>
                    </div>
                  </div>

                  {!loadingKidData && unsubscribedKids.length > 0 && (
                    <div
                      className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between p-3 mb-4 rounded-3 shadow-sm border-warning"
                      role="alert"
                      style={{ backgroundColor: "#FFF8E1", borderColor: "#FFE082" }}
                    >
                      <div className="d-flex align-items-center gap-3 mb-2 mb-md-0">
                        <i
                          className="fa-solid fa-circle-exclamation text-warning fs-3"
                          style={{ color: "#F57F17" }}
                        ></i>
                        <div>
                          <strong className="text-dark">
                            {unsubscribedKids.length === 1
                              ? "1 kid profile is saved but pending subscription payment."
                              : `${unsubscribedKids.length} kid profiles are saved but pending subscription payment.`}
                          </strong>
                          <div className="small text-muted">
                            Complete the payment to activate quests and learning episodes for your {unsubscribedKids.length === 1 ? "kid" : "kids"}.
                          </div>
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        {unsubscribedKids.length > 1 && (
                          <button
                            className="btn btn-warning fw-bold text-dark btn-sm px-3 rounded-pill shadow-sm"
                            onClick={handlePayAllPending}
                          >
                            Pay for All ({unsubscribedKids.length} Kids)
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {loadingKidData ? (
                    // Skeleton Placeholder Cards
                    <div className="row">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-md-6 col-sm-6 col-lg-3 mb-4"
                        >
                          <div className="card rounded-4 shadow-sm h-100 border-0">
                            <div className="card-body d-flex flex-column align-items-center text-center p-4">
                              <div
                                className="rounded-circle bg-light mb-3"
                                style={{ width: 80, height: 80 }}
                              ></div>
                              {["col-8", "col-6", "col-4", "col-7"].map(
                                (width, idx) => (
                                  <div
                                    className="placeholder-glow w-100 mb-1"
                                    key={idx}
                                  >
                                    <span
                                      className={`placeholder ${width} rounded`}
                                    ></span>
                                  </div>
                                ),
                              )}
                              <div className="d-grid gap-2 w-100 mt-auto">
                                <span className="btn btn-primary btn-sm disabled placeholder col-12 rounded-pill"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="row">
                      {Array.isArray(kidsData?.students) &&
                      kidsData.students.length > 0 ? (
                        (() => {
                          let firstUnsubscribedFound = false;

                          // Sort the kids so that unsubscribed ones come first
                          const sortedKids = [...kidsData.students].sort(
                            (a, b) => {
                              return a.is_subscribed === b.is_subscribed
                                ? 0
                                : a.is_subscribed
                                  ? 1
                                  : -1;
                            },
                          );

                          return sortedKids.map((kid) => {
                            const shouldShowButton = !kid?.is_subscribed;
                            const enableButton =
                              shouldShowButton && !firstUnsubscribedFound;

                            if (enableButton) {
                              firstUnsubscribedFound = true;
                            }

                            return (
                              <div
                                key={kid?.id}
                                className="col-md-6 col-sm-6 col-lg-3 mb-4"
                              >
                                <div
                                  className={`card rounded-4 shadow-sm h-100 position-relative pt-2`}
                                  style={{
                                    backgroundColor: !kid?.is_subscribed
                                      ? "#008EF4"
                                      : "white",
                                    color: !kid?.is_subscribed
                                      ? "white"
                                      : "black", // optional for contrast
                                  }}
                                >
                                  <div
                                    className="position-absolute top-0 end-0 "
                                    style={{
                                      cursor: "pointer",
                                      zIndex: 10,
                                      marginTop: "10px",
                                      marginRight: "20px",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        `/parent/quests/${kid?.id}/${kid?.name}`,
                                      )
                                    }
                                  >
                                    View
                                  </div>

                                  {shouldShowButton && (
                                    <div
                                      className="position-absolute top-0 start-0"
                                      style={{
                                        zIndex: 10,
                                        marginTop: "10px",
                                        marginLeft: "12px",
                                      }}
                                    >
                                      <span
                                        className="badge rounded-pill fw-bold text-dark px-2 py-1 shadow-sm d-inline-flex align-items-center gap-1"
                                        style={{
                                          backgroundColor: "#FFE082",
                                          fontSize: "11px",
                                          letterSpacing: "0.3px",
                                        }}
                                      >
                                        <i className="fa-regular fa-clock"></i>
                                        <span>Payment Pending</span>
                                      </span>
                                    </div>
                                  )}
                                  <div className="card-body d-flex flex-column align-items-center text-center p-4">
                                    <div
                                      className="rounded-circle bg-light d-flex align-items-center justify-content-center mb-3"
                                      style={{ width: "80px", height: "80px" }}
                                    >
                                      <Avatar
                                        name={kid?.name}
                                        size="100"
                                        round={true}
                                        color={`${
                                          !kid?.is_subscribed
                                            ? "#ffffff"
                                            : "#008EF4"
                                        }`}
                                        fgColor={
                                          kid?.is_subscribed
                                            ? "#ffffff"
                                            : "#008EF4"
                                        }
                                        className={`shadow-lg `}
                                      />
                                    </div>
                                    <h5 className="card-title fw-bold mt-4">
                                      {kid?.name.charAt(0).toUpperCase() +
                                        kid?.name.slice(1)}
                                    </h5>
                                    <p className=" medium mb-1 d-flex align-items-center gap-2">
                                      <strong>Username:</strong> {kid?.username}
                                      <i
                                        className="bi bi-pen"
                                        style={{ cursor: "pointer" }}
                                        title="Edit Username"
                                        onClick={() => {
                                          UsernameChange(kid);
                                        }}
                                      ></i>
                                    </p>

                                    {kid?.age >= 13 ? (
                                      <>
                                        <p className=" medium mb-1">
                                          <strong>Email:</strong> {kid?.email}
                                        </p>
                                        <p className=" medium mb-1">
                                          <strong>Age:</strong> {kid?.age}
                                        </p>
                                      </>
                                    ) : (
                                      <p className=" medium mb-1">
                                        <strong>Age:</strong> {kid?.age}
                                      </p>
                                    )}

                                    {shouldShowButton && (
                                      <div className="mt-auto w-100">
                                        <div className="d-grid gap-2 mt-2">
                                          <button
                                            className="btn btn-warning fw-bold text-dark rounded-pill py-2 shadow-sm d-flex align-items-center justify-content-center gap-2"
                                            style={{
                                              backgroundColor: "#FBC004",
                                              borderColor: "#FBC004",
                                              fontSize: "14px",
                                            }}
                                            onClick={() =>
                                              handleSingleKidPayment(kid.id)
                                            }
                                          >
                                            <i className="fa-solid fa-credit-card"></i>
                                            <span>Pay Now</span>
                                          </button>
                                          {unsubscribedKids.length > 1 && (
                                            <label
                                              className="d-flex align-items-center gap-2 justify-content-center small mt-1"
                                              style={{
                                                cursor: "pointer",
                                                color: "rgba(255,255,255,0.9)",
                                              }}
                                            >
                                              <input
                                                className="form-check-input custom-checkbox"
                                                type="checkbox"
                                                checked={selectedKids.includes(
                                                  kid.id,
                                                )}
                                                onChange={() =>
                                                  toggleKidSelection(kid.id)
                                                }
                                              />
                                              <span className="pt-1">
                                                Select for bulk pay
                                              </span>
                                            </label>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {!shouldShowButton &&
                                      Number(kid.age) < 13 && (
                                        <div className="mt-auto w-100">
                                          <div className="d-grid mt-2">
                                            <button
                                              className={`btn btn-outline-primary btn-md rounded-pill ${
                                                !kid?.is_subscribed
                                                  ? "text-black"
                                                  : "text-primary"
                                              }`}
                                              style={{
                                                backgroundColor: "#ffffff",
                                              }}
                                              onClick={() => {
                                                setStudentLoginId(kid.id);
                                                setShowModalParentLeave(true);
                                              }}
                                            >
                                              Go to Kid's Dashboard
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    <div className="mt-auto w-100">
                                      <div className="d-grid mt-3">
                                        <span
                                          className={`small text-decoration-underline ${
                                            !kid?.is_subscribed
                                              ? "text-wheat"
                                              : "text-black"
                                          }`}
                                          onClick={() => passwordChange(kid)}
                                          role="button" // makes it feel clickable for accessibility
                                        >
                                          Change Password
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          });
                        })()
                      ) : (
                        <div className="col-md-12 text-center">
                          <p>No kids data available.</p>
                        </div>
                      )}
                    </div>
                  )}

                  {showModal && (
                    <ParentEditKid
                      showModal={showModal} // Pass the modal visibility
                      handleQuestClose={() => setShowModal(false)} // Pass the close function
                      kid={kidToUpdate} // Pass the user object to delete
                    />
                  )}
                  {showModalUsername && (
                    <ParentEditKidUsername
                      showModal={showModalUsername}
                      handleQuestClose={() => setShowModalUsername(false)}
                      kid={kidToUpdate}
                      onSuccess={(updatedUsername) => {
                        setShowModalUsername(false);
                        setkidsData((prev) => ({
                          ...prev,
                          students: prev.students.map((kid) =>
                            kid.id === kidToUpdate.id
                              ? { ...kid, username: updatedUsername }
                              : kid,
                          ),
                        }));
                      }}
                    />
                  )}
                </div>
              </section>
              <div style={{}}>
                {/* Left Image */}
                <img
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
                  alt="left"
                  className="position-fixed"
                  style={{
                    left: 0,
                    top: "10vh",
                    height: "90vh",
                    bottom: "auto",
                    width: "auto",
                    zIndex: -1, // Keeps it in the background
                  }}
                />

                {/* Right Image */}
                <img
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
                  alt="right"
                  className="position-fixed"
                  style={{
                    right: 0,
                    top: "20vh",
                    height: "70vh",
                    width: "auto",
                    zIndex: -1, // Keeps it in the background
                  }}
                />

                {/* Page Content */}
              </div>
            </div>
          </div>
        </div>
        <LeaveParentDashboardModal
          show={showModalParentLeave}
          handleClose={() => setShowModalParentLeave(false)}
          handleContinue={handleSwitchStudent}
        />
        {kidsData?.students?.some((kid) => !kid.is_subscribed) &&
          selectedKids?.length > 0 && (
            <div
              className="position-fixed bottom-0 start-0 end-0 text-center pb-3"
              style={{ zIndex: 1050 }}
            >
              <div className="container">
                <button
                  className="btn btn-primary rounded-pill responsive-btn"
                  disabled={kidsData.students.every((kid) => kid.is_subscribed)}
                  onClick={handleBulkPayment}
                >
                  Complete Payment
                  {selectedKids?.length > 1 ? "s" : ""}
                </button>
              </div>
            </div>
          )}
      </div>
    </>
  );
};
